export const CLIENTES_ESTADO_FETCH_REQUEST = "CLIENTES_ESTADO_FETCH_REQUEST";
export const CLIENTES_ESTADO_FETCH_SUCCESS = "CLIENTES_ESTADO_FETCH_SUCCESS";
export const CLIENTES_ESTADO_FETCH_FAILURE = "CLIENTES_ESTADO_FETCH_FAILURE";
export const CLIENTES_ESTADO_FETCH_RESET = "CLIENTES_ESTADO_FETCH_RESET";

export const CLIENTES_LIST_FETCH_REQUEST = "CLIENTES_LIST_FETCH_REQUEST";
export const CLIENTES_LIST_FETCH_SUCCESS = "CLIENTES_LIST_FETCH_SUCCESS";
export const CLIENTES_LIST_FETCH_FAILURE = "CLIENTES_LIST_FETCH_FAILURE";
export const CLIENTES_LIST_FETCH_RESET = "CLIENTES_LIST_FETCH_RESET";
